// import React from 'react';
// import classNames from 'classnames';
// import { SectionTilesProps } from '../../utils/SectionProps';
// import SectionHeader from './partials/SectionHeader';

// const propTypes = {
//   ...SectionTilesProps.types
// }

// const defaultProps = {
//   ...SectionTilesProps.defaults
// }

// const Testimonial = ({
//   className,
//   topOuterDivider,
//   bottomOuterDivider,
//   topDivider,
//   bottomDivider,
//   hasBgColor,
//   invertColor,
//   pushLeft,
//   ...props
// }) => {

//   const outerClasses = classNames(
//     'testimonial section',
//     topOuterDivider && 'has-top-divider',
//     bottomOuterDivider && 'has-bottom-divider',
//     hasBgColor && 'has-bg-color',
//     invertColor && 'invert-color',
//     className
//   );

//   const innerClasses = classNames(
//     'testimonial-inner section-inner',
//     topDivider && 'has-top-divider',
//     bottomDivider && 'has-bottom-divider'
//   );

//   const tilesClasses = classNames(
//     'tiles-wrap',
//     pushLeft && 'push-left'
//   );

//   const sectionHeader = {
//     title: 'Customer testimonials',
//     paragraph: 'Vitae aliquet nec ullamcorper sit amet risus nullam eget felis semper quis lectus nulla at volutpat diam ut venenatis tellus—in ornare.'
//   };

//   return (
//     <section
//       {...props}
//       className={outerClasses}
//     >
//       <div className="container">
//         <div className={innerClasses}>
//           <SectionHeader data={sectionHeader} className="center-content" />
//           <div className={tilesClasses}>

//             <div className="tiles-item reveal-from-right" data-reveal-delay="200">
//               <div className="tiles-item-inner">
//                 <div className="testimonial-item-content">
//                   <p className="text-sm mb-0">
//                     — Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum cillum dolore eu fugiat.
//                       </p>
//                 </div>
//                 <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
//                   <span className="testimonial-item-name text-color-high">Roman Level</span>
//                   <span className="text-color-low"> / </span>
//                   <span className="testimonial-item-link">
//                     <a href="#0">AppName</a>
//                   </span>
//                 </div>
//               </div>
//             </div>

//             <div className="tiles-item reveal-from-bottom">
//               <div className="tiles-item-inner">
//                 <div className="testimonial-item-content">
//                   <p className="text-sm mb-0">
//                     — Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum cillum dolore eu fugiat.
//                       </p>
//                 </div>
//                 <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
//                   <span className="testimonial-item-name text-color-high">Diana Rynzhuk</span>
//                   <span className="text-color-low"> / </span>
//                   <span className="testimonial-item-link">
//                     <a href="#0">AppName</a>
//                   </span>
//                 </div>
//               </div>
//             </div>

//             <div className="tiles-item reveal-from-left" data-reveal-delay="200">
//               <div className="tiles-item-inner">
//                 <div className="testimonial-item-content">
//                   <p className="text-sm mb-0">
//                     — Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum cillum dolore eu fugiat.
//                       </p>
//                 </div>
//                 <div className="testimonial-item-footer text-xs mt-32 mb-0 has-top-divider">
//                   <span className="testimonial-item-name text-color-high">Ben Stafford</span>
//                   <span className="text-color-low"> / </span>
//                   <span className="testimonial-item-link">
//                     <a href="#0">AppName</a>
//                   </span>
//                 </div>
//               </div>
//             </div>

//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// Testimonial.propTypes = propTypes;
// Testimonial.defaultProps = defaultProps;

// export default Testimonial;

import React from 'react';
import classNames from 'classnames';
import { SectionTilesProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import Button from '../elements/Button';

const propTypes = {
  ...SectionTilesProps.types
}

const defaultProps = {
  ...SectionTilesProps.defaults
}
const TeamSection = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  pushLeft,
  ...props
}) => {

  const outerClasses = classNames(
    'TeamSection',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-tiles-inner section-inner pt-0',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const tilesClasses = classNames(
    'tiles-wrap center-content',
    pushLeft && 'push-left'
  );

  const sectionHeader = {
    title: 'Team of Bit Rebels',
    paragraph: 'We have a great team for mentoring and Managing the Students during the event'
  };

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={tilesClasses}>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/harshpurohit.jfif')}
                      alt="Features tile icon 01"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                  <h4 className="mt-0 mb-8">
                    Harshvardhan
                    </h4>
                  <Button tag="a" color={"primary"} href="https://www.linkedin.com/in/harshvardhan-purohit-4699691a6/" target="_blank" rel="noopener noreferrer" >Linkedin</Button>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/diksha.jfif')}
                      alt="Features tile icon 02"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                <h4 className="mt-0 mb-8">
                    Diksha Vyas
                    </h4>
                  <Button   tag="a" color={"primary"} href="https://www.linkedin.com/in/dikshavyas/" target="_blank" rel="noopener noreferrer">Linkedin</Button>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/pranav.jfif')}
                      alt="Features tile icon 03"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                <h4 className="mt-0 mb-8">
                    Pranav Sharma
                    </h4>
                  <Button  tag="a" color={"primary"} href="https://www.linkedin.com/in/pranav-sharma-76b45b205/" target="_blank" rel="noopener noreferrer">Linkedin</Button>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/rachit.jfif')}
                      alt="Features tile icon 04"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                <h4 className="mt-0 mb-8">
                    Rachit Mathur
                    </h4>
                  <Button  tag="a" color={"primary"} href="https://www.linkedin.com/in/rachit-mathur-670127217/" target="_blank" rel="noopener noreferrer">Linkedin</Button>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="200">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/pranjil.jfif')}
                      alt="Features tile icon 05"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                <h4 className="mt-0 mb-8">
                    Pranjil Sankhla
                    </h4>
                  <Button  tag="a" color={"primary"} href="https://www.linkedin.com/in/pranjil-sankhla-4255b6257/" target="_blank" rel="noopener noreferrer">Linkedin</Button>
                </div>
              </div>
            </div>

            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/harsh.jfif')}
                      alt="Features tile icon 06"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                <h4 className="mt-0 mb-8">
                    Harsh Asopa
                    </h4>
                  <Button  tag="a" color={"primary"} href="https://www.linkedin.com/in/harsh-asopa-abb3501ba/" target="_blank" rel="noopener noreferrer">Linkedin</Button>
                </div>
                
              </div>
            </div>
            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/bhuv.jfif')}
                      alt="Features tile icon 06"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                <h4 className="mt-0 mb-8">
                    Bhuvnesh Parihar
                    </h4>
                  <Button  tag="a" color={"primary"} href="https://www.linkedin.com/in/bhuvnesh-parihar-619ab81b9/" target="_blank" rel="noopener noreferrer">Linkedin</Button>
                </div>
                
              </div>
            </div>
            <div className="tiles-item reveal-from-bottom" data-reveal-delay="400">
              <div className="tiles-item-inner">
                <div className="features-tiles-item-header">
                  <div className="features-tiles-item-image mb-16">
                    <Image
                      src={require('./../../assets/images/anu.jfif')}
                      alt="Features tile icon 06"
                      width={64}
                      height={64} />
                  </div>
                </div>
                <div className="features-tiles-item-content">
                <h4 className="mt-0 mb-8">
                    Anupam Mishra
                    </h4>
                  <Button  tag="a" color={"primary"} href="https://www.linkedin.com/in/anupam--mishra/" target="_blank" rel="noopener noreferrer">Linkedin</Button>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

TeamSection.propTypes = propTypes;
TeamSection.defaultProps = defaultProps;

export default TeamSection;